export default "__VITE_ASSET__57421161__"